import { IResourceListProps } from "../../common/ra-types";
import {
  useListContext,
  Filter,
  TextInput,
  CreateButton,
  Datagrid,
  TextField,
  NumberField,
  FunctionField,
} from "react-admin";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import FolderSharedOutlinedIcon from "@material-ui/icons/FolderSharedOutlined";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { ArrayField } from "../../common/data-grid-fields/ArrayField";
import { Box, Theme, useTheme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { AppState } from "../../../common/types";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import ProLogsDateField from "../../common/data-grid-fields/ProLogsDateField";

export const SubscriptionsList = (props: IResourceListProps) => {
  const themeName = useSelector((state: AppState) => state.theme);
  const theme: Theme = useTheme();

  const ListFilter = (props: any) => {
    const { loading } = useListContext();
    useSearchFields(props, ["subscriptionName"]);
    return (
      <Filter {...props}>
        {!loading && (
          <TextInput
            className="subscriptions-list-filter search-box"
            label="resources.common.labels.search"
            source="q"
            alwaysOn
            autoFocus
            autoComplete="off"
          />
        )}
        {loading && (
          <TextInput
            className="subscriptions-list-filter search-box"
            label="resources.common.labels.search"
            source="q"
            alwaysOn
          />
        )}
      </Filter>
    );
  };

  const ListActions = () => {
    const { basePath } = useListContext();
    return (
      <>
        <CreateButton basePath={basePath} />
      </>
    );
  };
  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={FolderSharedOutlinedIcon} />}
        className="content-list"
        title="resources.master-subscriptions.name"
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        {...props}
      >
        <Datagrid>
          <TextField
            source="tenantName"
            label="resources.master-subscriptions.labels.tenantName"
          />
          <ProLogsDateField
            source="expirationDate"
            label="resources.master-subscriptions.labels.expirationDate"
          />
          <FunctionField<any>
            source="isAutoRenew"
            headerClassName="centered-content"
            label="resources.master-subscriptions.labels.isAutoRenew"
            render={(record?: any) => (
              <Box className="centered-content">
                {record?.isAutoRenew ? (
                  <CheckBoxIcon
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.success.dark
                          : theme.palette.success.light,
                    }}
                  />
                ) : (
                  <IndeterminateCheckBoxIcon
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.error.dark
                          : theme.palette.error.light,
                    }}
                  />
                )}
              </Box>
            )}
          />
          <FunctionField<any>
            source="isTrial"
            headerClassName="centered-content"
            label="resources.master-subscriptions.labels.isTrial"
            render={(record?: any) => (
              <Box className="centered-content">
                {record?.isTrial ? (
                  <CheckBoxIcon
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.success.dark
                          : theme.palette.success.light,
                    }}
                  />
                ) : (
                  <IndeterminateCheckBoxIcon
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.error.dark
                          : theme.palette.error.light,
                    }}
                  />
                )}
              </Box>
            )}
          />
          <ArrayField
            source="featureNames"
            label="resources.master-subscriptions.labels.featureNames"
            displayedElementsCount={2}
            emptyArrayDisplay="resources.master-subscriptions.labels.noFeatures"
          />
          <NumberField
            source="rentedEldsCount"
            label="resources.master-subscriptions.labels.rentedEldsCount"
          />
          <FunctionField<any>
            source="status"
            headerClassName="centered-content"
            label="resources.common.labels.active"
            render={(record?: any) => (
              <Box className="centered-content">
                {record?.status === "Active" ? (
                  <CheckBoxIcon
                    className={record.status}
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.success.dark
                          : theme.palette.success.light,
                    }}
                  />
                ) : (
                  <IndeterminateCheckBoxIcon
                    className={record?.status}
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.error.dark
                          : theme.palette.error.light,
                    }}
                  />
                )}
              </Box>
            )}
          />
          <ActionsField editable={(_) => true} />
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
